import React, { useEffect, useRef, useState } from "react";
import "./chat.css";
import {
  EllipsisVertical,
  Group,
  MessageCirclePlus,
  Pen,
  Pencil,
  PlusIcon,
  SearchIcon,
  Trash2Icon,
  Users,
} from "lucide-react";
import ChatUserModal from "./ChatUserModal";
import apiServiceHandler from "../../service/apiService";
import { useDispatch, useSelector } from "react-redux";
import {
  handleCurrentUserMessages,
  updateChatCount,
  updateCurrentPage,
  updateDeleteChat,
  updateDelteFunc,
  updateNewChat,
  updateSortChat,
} from "../../redux/chatData";
import { getColorFromName } from "../../utils/getColor";
import toastr from "toastr";
import HashLoader from "react-spinners/HashLoader";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";
import { firestore } from "../../firebase";
import EditChatNameModal from "./EditChatName";
import AddMembersModal from "./AddMembersModal";

const ChatContainer = ({ activeChat, setActiveChat, setResfreshChat }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [chatModal, setChatModal] = useState(false);
  const [editChatNameModal, setEditChatNameModal] = useState(false);
  const [addMembersModal, setAddMembersModal] = useState(false);
  const [editChat, setEditChat] = useState(null);
  const [chats, setChats] = useState([]);

  const [popoverChatId, setPopoverChatId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(0);
  const [noMoreChats, setNoMoreChats] = useState(false);
  const limit = 10;
  const newChat = useSelector((state) => state.chatData.newChat);
  const dispatch = useDispatch();
  const checkDelete = useSelector((state) => state.chatData.checkDelete);
  const sortChat = useSelector((state) => state.chatData.sortChat);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const isAdmin = userDetails?.admin;
  const unreadMessagesCount = useSelector(
    (state) => state.chatData.unreadMessagesCount
  );
  const unreadChatNotifications = useSelector(
    (state) => state.chatData.unreadChatNotifications
  );
  const deleteChatItem = useSelector(
    (state) => state.chatData.deleteChat
  );

  const toggleChatModal = () => {
    setChatModal(!chatModal);
  };

  const toggleEditChatModal = (chat) => {
    setEditChatNameModal(!editChatNameModal);
    setEditChat(chat);
    setResfreshChat(true);
  };

  const toggleAddMembersModal = () => {
    setAddMembersModal(!addMembersModal);
  };

  const handleInputFocus = (chatId) => {
    setPopoverChatId((prev) => (prev === chatId ? null : chatId));
  };

  const getAllChats = async (pageNum = 0) => {
    try {
      setLoading(pageNum === 0);
      setLoadingMore(pageNum > 0);
      const response = await apiServiceHandler(
        "GET",
        `api/chat/list?page=${pageNum}&offset=${limit}`,
        {}
      );

      // console.log(response, 'Get API response')

      if (!response?.data) {
        setLoading(false);
        return;
      }

      const groupCollectionRef = collection(firestore, "group");

      const sortedContactsQuery = query(
        groupCollectionRef,
        orderBy("lastMessageTimestamp", "desc")
      );

      const querySnapshot = await getDocs(sortedContactsQuery);

      const groupData = querySnapshot.docs.map(doc => {
        const data = doc.data(); // Get document data
        return {
          groupId: doc.id, 
          lastMessageTimestamp: data.lastMessageTimestamp, 
        };
      });

      const sortedArray = response.data[0].data.sort((a, b) => {
        // Get lastMessageTimestamp from sortedContactIds if it exists
        const lastMessageA = groupData.find(
          (data) => data?.groupId == a._id
        )?.lastMessageTimestamp?.seconds
        const lastMessageB = groupData.find(
          (data) => data?.groupId == b._id
        )?.lastMessageTimestamp?.seconds

        // Use lastMessageTimestamp from sortedContactIds or fallback to updated_at
        // const timestampA = lastMessageA || a.updated_at;
        // const timestampB = lastMessageB || b.updated_at;
        
        const timestampA = lastMessageA 
        const timestampB = lastMessageB

        // Convert timestamps to Date objects
        const dateA = timestampA ? new Date(timestampA) : null;
        const dateB = timestampB ? new Date(timestampB) : null;

        // Sort by valid timestamps
        if (dateA && dateB) {
          return dateB - dateA; // Descending order
        }
      
        if (dateA) return -1; // Place items with valid timestamps above those without
        if (dateB) return 1;
      
        // If neither has valid timestamps, maintain their original order
        return 0;
      });
      
    
      if (response.data.length > 0) {
        setActiveChat(
          checkDelete ? sortedArray[0] : activeChat ?? sortedArray[0]
        );
      }
      dispatch(updateChatCount(sortedArray?.length));
      dispatch(updateDelteFunc(false));

      if (pageNum === 0) {
        setChats(sortedArray);
        setActiveChat(...sortedArray);
        setNoMoreChats(
          response.data[0].total > sortedArray.length ? false : true
        );
      } else {
        if (sortedArray.length < limit) {
          setNoMoreChats(true);
        }
        setChats((prevChats) => [...prevChats, ...sortedArray]);
        setActiveChat(...(prevChats) => [...prevChats, ...sortedArray]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error getting users:", error);
      setLoading(false);
    } finally {
      if (pageNum == 0) {
        setLoading(false);
      }
      setLoadingMore(false);
    }
  };

  const deleteChat = async (id) => {
    const payload = {
      chatId: id,
    };

    try {
      const response = await apiServiceHandler(
        "POST",
        "api/chat/remove",
        payload
      );
      if (response.status) {
        // const chatDoc = doc(firestore, "group", activeChat?._id);
        // await deleteDoc(chatDoc);
        dispatch(handleCurrentUserMessages([]));
        dispatch(updateDelteFunc(true));
        // dispatch(updateNewChat(true));
        const updateChats = chats?.filter((chat) => chat._id !== id);
        setChats(updateChats);
        dispatch(updateChatCount(updateChats.length));
        dispatch(updateDeleteChat(true))
        toastr.success(response.message);
      }
    } catch (error) {
      console.error("Error getting users:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (deleteChatItem) {
      setActiveChat(chats[0])
    }
    dispatch(updateDeleteChat(false))
  }, [deleteChatItem])

  useEffect(() => {
    getAllChats();
    setResfreshChat(false);
  }, [setResfreshChat]);

  useEffect(() => {
    if (sortChat) {
      const currentChat = chats.find((chat) => chat._id === activeChat?._id);
      const remainingChats = chats.filter(
        (chat) => chat._id !== activeChat?._id
      );
      const updatedChats = [currentChat, ...remainingChats];

      setChats(updatedChats);
    }
    dispatch(updateSortChat(false));
  }, [sortChat]);

  useEffect(() => {
    if (newChat) {
      getAllChats();
      setPage(0);
    }
    dispatch(updateNewChat(false));
  }, [newChat]);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    getAllChats(nextPage);
  };

  return (
    <>
      <div className="chat-view">
        <div className="thread-list">
          <div className="header-thread-container">
            <div className="search-thread-container">
              <div className="chat-text-input">
                <div className="chat-text-input_input-wrapper">
                  <input
                    type="text"
                    className="text-input__input"
                    placeholder="Search Conversations"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <SearchIcon
                    style={{
                      width: "20px",
                      height: "20px",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="new-message-container">
              <button
                className="new-converstation-add-btn"
                onClick={toggleChatModal}
              >
                <span className="plus-icon">
                  <MessageCirclePlus />
                </span>
                <span className="new-conversation-add-label">
                  New Conversation
                </span>
              </button>
            </div>
          </div>

          {/* thread list */}
          <div className="list-scroll">
            {!loading ? (
              chats && chats?.length > 0 ? (
                <>
                  {chats.map((chat) => {
                    const hasUnreadNotifications = Object.keys(unreadChatNotifications).length > 0 && unreadChatNotifications?.some(
                      (notification) => notification.chatId === chat._id && !notification.read
                    )
                    return (
                      <div
                      className={`thread-list__item ${
                        activeChat._id === chat?._id ? "active" : ""
                      }`}
                      key={chat?._id}
                      onClick={() => {
                        setActiveChat(chat);
                      }}
                      // style={{
                      //   backgroundColor: hasUnreadNotifications ? "#fca5a5" : "",
                      // }}
                    >
                      <div className="thread-list__item-avatar">
                        <div className="avatar-group__wrapper">
                          <div className="avatar-group__avatar">
                            <div
                              className="thread-avatar"
                              style={{
                                backgroundColor: getColorFromName(chat?.name),
                              }}
                            >
                              <div className="chat-avatar__image">
                                {chat && chat?.image ? (
                                  <img
                                    className="avatar__image"
                                    src={chat?.image}
                                    alt="User Avatar"
                                  />
                                ) : (
                                  <div className="user__avatar">
                                    {chat?.name?.substr(0, 1)}
                                  </div>
                                )}
                              </div>
                            </div>
                            
                          </div>
                        </div>
                        {hasUnreadNotifications && <span className="dot"></span>}
                      </div>
                      <div className="thread-list__item-details">
                        <div className="name bold truncate">{chat?.name}</div>
                        {unreadMessagesCount[chat._id] > 0 && (
                          <span>{unreadMessagesCount[chat._id]}</span>
                        )}
                        <div className="text-description">
                          <span className="width80"></span>
                        </div>
                      </div>
                      <span
                        className="thread-dropdown-menu"
                        onMouseLeave={() => setPopoverChatId(null)}
                      >
                        {isAdmin && (
                          <div className="dropdown-activator">
                            <button
                              className="activator-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                handleInputFocus(chat?._id);
                              }}
                            >
                              <EllipsisVertical
                                fill="#d1b794"
                                color="#d1b794"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                              />
                              {popoverChatId == chat?._id && (
                                <div className="dropdown-popover">
                                  <div
                                    className="dropdown-content"
                                    style={{
                                      display: "flex",
                                      width: "150px",
                                      padding: "0.7rem 1rem",
                                      color: "#604b51",
                                    }}
                                  >
                                    <div
                                      className="dropdown-item"
                                      style={{
                                        fontSize: "14px",
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        marginLeft: "0",
                                        gap: "0.4rem",
                                      }}
                                      onClick={() => deleteChat(chat?._id)}
                                    >
                                      <Trash2Icon
                                        style={{
                                          width: "12px",
                                          height: "12px",
                                        }}
                                      />
                                      Delete Chat
                                    </div>
                                    <div
                                      className="dropdown-item"
                                      style={{
                                        fontSize: "14px",
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        marginLeft: "0",
                                        gap: "0.4rem",
                                      }}
                                      onClick={() => toggleEditChatModal(chat)}
                                    >
                                      <Pen
                                        style={{
                                          width: "12px",
                                          height: "12px",
                                        }}
                                      />
                                      Edit Chat Name
                                    </div>
                                    <div
                                      className="dropdown-item"
                                      style={{
                                        fontSize: "14px",
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        marginLeft: "0",
                                        gap: "0.4rem",
                                      }}
                                      onClick={() =>
                                        toggleAddMembersModal(chat)
                                      }
                                    >
                                      <Users
                                        style={{
                                          width: "12px",
                                          height: "12px",
                                        }}
                                      />
                                      Add Members
                                    </div>
                                  </div>
                                </div>
                              )}
                            </button>
                          </div>
                        )}
                      </span>
                    </div>
                    )
                  })}
                  {!noMoreChats ? (
                    <button
                      onClick={handleLoadMore}
                      disabled={loadingMore}
                      className="load-more-chats"
                    >
                      {loadingMore ? (
                        <div className="member-loader">
                          <HashLoader color="#d1b794" size={20} />
                          <p>Loading more chats</p>
                        </div>
                      ) : (
                        <span>Load more chats</span>
                      )}
                    </button>
                  ) : (
                    <p
                      className="load-more-chats-btn"
                      style={{ color: "#969696" }}
                    >
                      No More Chats.
                    </p>
                  )}
                </>
              ) : (
                <div
                  style={{
                    position: "relative",
                    left: "30%",
                    marginTop: "1rem",
                    color: "#969696",
                  }}
                >
                  No Chats Found.
                </div>
              )
            ) : (
              <div
                className="member-loader"
                style={{
                  position: "relative",
                  left: "0%",
                  marginTop: "1rem",
                }}
              >
                <HashLoader color="#d1b794" size={20} />
                <p>Loading Chats</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <ChatUserModal isOpen={chatModal} onClose={toggleChatModal} />
      <EditChatNameModal
        isOpen={editChatNameModal}
        onClose={toggleEditChatModal}
        chat={editChat}
      />
      <AddMembersModal
        isOpen={addMembersModal}
        onClose={toggleAddMembersModal}
        chatId={activeChat?._id}
      />
    </>
  );
};

export default ChatContainer;
